import React, { useState, SVGProps } from 'react'
import styled from 'styled-components'

const TabsWrapper = styled.div`
  display: flex;
  border-bottom: 1px solid #e7eaf3;
`

const TabElement = styled.div<{ selected: boolean }>`
  padding: 1rem 1.5rem;
  display: flex;
  justify-content-center;
  align-items: center;
  border-radius: 3px 3px 0px 0px;
  ${(props) =>
    props.selected &&
    'font-weight: bold; color: #237D83; background: #F2F7F8; border-bottom: 2px solid #237D83;'};
  &:hover {
    cursor: pointer;
    background: #F2F7F8;
  }
`

interface ITab {
  label: string
  selected: boolean
  Icon?: (props: SVGProps<SVGSVGElement>) => JSX.Element
  [key: string]: any
}

const Tab: React.FC<ITab> = ({ label, selected, Icon, ...rest }) => {
  return (
    <TabElement
      selected={selected}
      className="noselect"
      // Custom attributes for testing purposes
      data-tabname={label}
      data-selected={selected}
      {...rest}
    >
      {Icon && (
        <Icon
          style={{ margin: '0 8px 3px 0' }}
          color={selected ? '#237D83' : ''}
        />
      )}
      <div>{label}</div>
    </TabElement>
  )
}

interface ITabsProps {
  tabs: {
    label: string
    Icon?: (props: SVGProps<SVGSVGElement>) => JSX.Element
  }[]
  onSelect?: (i: number) => void
  [key: string]: any
}

export const Tabs: React.FC<ITabsProps> = ({ tabs, onSelect, ...rest }) => {
  const [selectedIndex, setSelectedIndex] = useState(0)

  const handleSelect = (index: number) => {
    setSelectedIndex(index)
    onSelect !== undefined && onSelect(index)
  }

  return (
    <TabsWrapper {...rest}>
      {tabs.map((tab, i) => (
        <Tab
          key={i}
          label={tab.label}
          selected={i === selectedIndex}
          Icon={tab.Icon}
          onClick={() => handleSelect(i)}
        />
      ))}
    </TabsWrapper>
  )
}
